import React from "react";

export default function SignalStrength({ level = "HIGH" }) {
  const getColor = (index) => {
    if (level === "HIGH") {
      return "#22c55e"; // green
    }
    if (level === "MEDIUM") {
      return index < 3 ? "#f59e0b" : "#d1d5db"; // orange then grey
    }
    if (level === "LOW") {
      return index < 1 ? "#ef4444" : "#d1d5db"; // red then grey
    }
    return "#d1d5db"; // default grey
  };

  const barHeights = [4, 8, 12, 16, 20];

  return (
    <svg width="18" height="18" viewBox="0 0 24 24">
      {barHeights.map((height, index) => (
        <rect
          key={index}
          x={4 + index * 4}
          y={18 - height}
          width="2"
          height={height}
          rx="1"
          fill={getColor(index)}
        />
      ))}
    </svg>
  );
}
